import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {setAppointmentEMPexportAction , setSalaryEMPexportAction,
  setSalaryRevisionChangeAction ,
  setContractRenewalAction,
  setSalaryexport_revision_Action,
  setWarningPoorPerformanceAction,
  setShowCauseAbscondingAction,
  setGenerated_letterAction
} from "../../../Redux/Slice";
const Lettersexports = () => {
      const dispatch = useDispatch();
      const state = useSelector((state) => state);
    
const handleSalaryRevision = () => {
  const employeeDateOfJoining = state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining;
  Swal.fire({
    title: "Select Revised Salary Date",
    html: `
      <input 
        type="date" 
        id="revisedDate" 
        class="swal2-input" 
          min="${employeeDateOfJoining}"  // 👈 restrict earlier dates

        style="width: 74%; box-sizing: border-box;"
      />
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Generate Letter",
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",

    // 👉 Custom class for removing padding
    customClass: {
      htmlContainer: "no-padding-html",
    },

    preConfirm: () => {
      const date = document.getElementById("revisedDate").value;

      if (!date) {
        Swal.showValidationMessage("Please select a date");
        return false;
      }
      return date;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const revised_salary_date = result.value;
       const payload = {
              user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              revised_salary_date:revised_salary_date
            };
  
  
            dispatch(setSalaryEMPexportAction(payload));
            
      console.log("Selected Revised Salary Date:", revised_salary_date);

    }
  });
};

  // const handleAppointmentLetter = () => {
  //   Swal.fire({
  //     title: "Generate Appointment Letter?",
  //     text: "Do you want to download the Appointment Letter?",
  //     icon: "question",
  //     showCancelButton: true,
  //           confirmButtonColor: "#f26639",
  //     cancelButtonColor: "#F69338",

  //     confirmButtonText: "Yes, Generate",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //           const payload = {
  //             user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
  //           };
  
  
  //           dispatch(setAppointmentEMPexportAction(payload));
  //     }
  //   });
  // };

  const handleAppointmentLetter = () => {
      const employeeDateOfJoining = state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining ? state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining :"";

  Swal.fire({
    title: "Generate Appointment Letter?",
    html: `
      <p style="margin-bottom:8px">
        Do you want to download the Appointment Letter?
      </p>
      <input 
        type="date" 
        id="end_date" 
        class="swal2-input"
        placeholder="End Date (optional)"
       min="${employeeDateOfJoining}"  // 👈 restrict earlier dates

      />
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",
    confirmButtonText: "Yes, Generate",
    preConfirm: () => {
      return document.getElementById("end_date").value || null;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const payload = {
        user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        ...(result.value && { end_date: result.value }), // optional
      };

      dispatch(setAppointmentEMPexportAction(payload));
    }
  });
};

  
// const handleSalaryRevision_new = (type) => {
//   const employeeDateOfJoining =
//     state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining;

//   let titleText = "";
//   let dateLabel = "";
  
//   if (type === "mw_revision") {
//     titleText = "Select MW Revised Salary Date";
//     dateLabel = "mw_revised_salary_date";
//   } 
//   else if (type === "contract") {
//     titleText = "Select Contract Renewal Dates";
//     dateLabel = "contract_extended_date"; // start & end will be handled separately
//   }
//   else if (type === "letter_changes") {
//     titleText = "Select Date for Salary Structure Change";
//     dateLabel = "letter_change_salary_structure_revised_date";
//   }

//   Swal.fire({
//     title: titleText,
//     html: `
//       ${
//         type === "contract"
//           ? `
//         <label style="font-size:14px;margin-bottom:5px;">Contract Start Date</label>
//         <input type="date" id="contractStart" class="swal2-input" min="${employeeDateOfJoining}"
//           style="width: 74%; box-sizing: border-box;" />
        
//         <label style="font-size:14px;margin-bottom:5px;">Contract End Date</label>
//         <input type="date" id="contractEnd" class="swal2-input" min="${employeeDateOfJoining}"
//           style="width: 74%; box-sizing: border-box;" />
//       `
//           : `
//         <input type="date" id="${dateLabel}" class="swal2-input"
//           min="${employeeDateOfJoining}" style="width: 74%; box-sizing: border-box;" />
//       `
//       }
//     `,
//     icon: "question",
//     showCancelButton: true,
//     confirmButtonText: "Generate Letter",
//     confirmButtonColor: "#f26639",
//     cancelButtonColor: "#F69338",
//     customClass: { htmlContainer: "no-padding-html" },

//     preConfirm: () => {
//       if (type === "contract") {
//         const start = document.getElementById("contractStart").value;
//         const end = document.getElementById("contractEnd").value;

//         if (!start || !end) {
//           Swal.showValidationMessage("Please select both start and end dates");
//           return false;
//         }
//         return { start, end };
//       } else {
//         const date = document.getElementById(dateLabel).value;

//         if (!date) {
//           Swal.showValidationMessage("Please select a date");
//           return false;
//         }
//         return date;
//       }
//     },
//   }).then((result) => {
//     if (!result.isConfirmed) return;

//     const userId = state.EmployeeProfile.EmployeeProfileList.user_id.id;

//     // Payloads for each case
//     let payload = {};

//     if (type === "mw_revision") {
//       payload = {
//         user_id: userId,
//         mw_revised_salary_date: result.value,
//       };
//       dispatch(setSalaryexport_revision_Action(payload));
//     }

//     if (type === "contract") {
//       payload = {
//         user_id: userId,
//         contract_extended_start_date: result.value.start,
//         contract_extended_end_date: result.value.end,
//       };
//       dispatch(setContractRenewalAction(payload));
//     }

//     if (type === "letter_changes") {
//       payload = {
//         user_id: userId,
//         letter_change_salary_structure_revised_date: result.value,
//       };
//       dispatch(setSalaryRevisionChangeAction(payload));
//     }

//     console.log("Generated Payload:", payload);
//   });
// };

const handleSalaryRevision_new = (type) => {
  const employeeDateOfJoining =
    state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining;

  // 👉 FIRST POPUP: choose revision type
  if (type === "salary_revision") {
    Swal.fire({
      title: "Select Salary Revision Type",
      html: `
        <select id="revisionType" class="swal2-select" style="width:74%">
          <option value="">Select Option</option>
                    <option value="salary_revision">Salary Revision</option>

          <option value="mw_revision">MW Revision</option>
          <option value="letter_changes">Salary Structure Revision</option>
        </select>
      `,
      showCancelButton: true,
      confirmButtonText: "Next",
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      preConfirm: () => {
        const val = document.getElementById("revisionType").value;
        if (!val) {
          Swal.showValidationMessage("Please select an option");
          return false;
        }
        return val;
      },
    }).then((res) => {
      if (res.isConfirmed) {
        console.log(res.value ,"saoidauosdiuas dres.value");
        
        if(res.value == "salary_revision"){
    handleSalaryRevision()
        }
        else {
        handleSalaryRevision_new(res.value); // 🔁 re-call with actual type
        }
      }
    });
    return;
  }


  // 👉 EXISTING LOGIC CONTINUES
  let titleText = "";
  let dateLabel = "";

  if (type === "mw_revision") {
    titleText = "Select MW Revised Salary Date";
    dateLabel = "mw_revised_salary_date";
  } else if (type === "contract") {
    titleText = "Select Contract Renewal Dates";
  } else if (type === "letter_changes") {
    titleText = "Select Date for Salary Structure Change";
    dateLabel = "letter_change_salary_structure_revised_date";
  }

  Swal.fire({
    title: titleText,
    html: `
      ${
        type === "contract"
          ? `
          <label>Contract Start Date</label>
          <input type="date" id="contractStart" class="swal2-input"
            min="${employeeDateOfJoining}" style="width:74%" />
          
          <label>Contract End Date</label>
          <input type="date" id="contractEnd" class="swal2-input"
            min="${employeeDateOfJoining}" style="width:74%" />
        `
          : `
          <input type="date" id="${dateLabel}" class="swal2-input"
            min="${employeeDateOfJoining}" style="width:74%" />
        `
      }
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Generate Letter",
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",

    preConfirm: () => {
      if (type === "contract") {
        const start = document.getElementById("contractStart").value;
        const end = document.getElementById("contractEnd").value;

        if (!start || !end) {
          Swal.showValidationMessage("Please select both dates");
          return false;
        }
        return { start, end };
      } else {
        const date = document.getElementById(dateLabel).value;
        if (!date) {
          Swal.showValidationMessage("Please select a date");
          return false;
        }
        return date;
      }
    },
  }).then((result) => {
    if (!result.isConfirmed) return;

    const userId = state.EmployeeProfile.EmployeeProfileList.user_id.id;
    let payload = {};

    if (type === "mw_revision") {
      payload = { user_id: userId, mw_revised_salary_date: result.value };
      dispatch(setSalaryexport_revision_Action(payload));
    }

    if (type === "letter_changes") {
      payload = {
        user_id: userId,
        letter_change_salary_structure_revised_date: result.value,
      };
      dispatch(setSalaryRevisionChangeAction(payload));
    }

    if (type === "contract") {
      payload = {
        user_id: userId,
        contract_extended_start_date: result.value.start,
        contract_extended_end_date: result.value.end,
      };
      dispatch(setContractRenewalAction(payload));
    }

    console.log("Generated Payload:", payload);
  });
};





const handlethe_warining = () => {
  Swal.fire({
    title: "Generate Warning Letter",
    html: `
      <select id="warningType" class="swal2-select" style="width:85%">
        <option value="">Select Warning Type</option>
        <option value="poor_performace">Poor Performance</option>
        <option value="pip">PIP</option>
        <option value="indiscipline">Indiscipline</option>
      </select>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",
    confirmButtonText: "Yes, Generate",
    preConfirm: () => {
      const warningType = document.getElementById("warningType").value;
      if (!warningType) {
        Swal.showValidationMessage("Please select a warning type");
      }
      return warningType;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const payload = {
        user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        warning_type: result.value, // poor_performace | pip | indiscipline
      };

      dispatch(setWarningPoorPerformanceAction(payload));
    }
  });
};


const handleshowcause = () => {
  Swal.fire({
    title: "Generate Show Cause Letter",
    html: `
      <select id="showCauseType" class="swal2-select" style="width:85%">
        <option value="">Select Show Cause Type</option>
        <option value="absconding">Absconding</option>
        <option value="false_attendance">False Attendance</option>
        <option value="false_bill_submission">False Bills Submission</option>

      </select>

      <textarea 
        id="reason"
        class="swal2-textarea"
        placeholder="Enter reason"
        style="width:85%"
      ></textarea>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",
    confirmButtonText: "Yes, Generate",
    preConfirm: () => {
      const type = document.getElementById("showCauseType").value;
      const reason = document.getElementById("reason").value;

      if (!type) {
        Swal.showValidationMessage("Please select a show cause type");
        return false;
      }
      if (!reason.trim()) {
        Swal.showValidationMessage("Please enter the reason");
        return false;
      }

      return { type, reason };
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const payload = {
        user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        showcause_type: result.value.type,
        reason: result.value.reason,
      };

      dispatch(setShowCauseAbscondingAction(payload));
    }
  });
};

const handleGenerateLetter = (type) => {
  const optionsHtml =
    type === "letters"
      ? `
        <option value="">Select Letter</option>
        <option value="transfer">Transfer Letter</option>
        <option value="relieving">Relieving Letter</option>
        <option value="experience">Experience Letter</option>
      `
      : `
        <option value="">Select Option</option>
        <option value="relinquishment">Relinquishment From Services</option>
        <option value="designation_change">Designation Change</option>
        <option value="role_change">Role Change</option>
      `;

  Swal.fire({
    title: type === "letters" ? "Generate Letter" : "Generate Other Document",
    html: `
      <select id="letterType" class="swal2-select" style="width:85%">
        ${optionsHtml}
      </select>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Generate",
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",
    preConfirm: () => {
      const value = document.getElementById("letterType").value;
      if (!value) {
        Swal.showValidationMessage("Please select an option");
      }
      return value;
    },
  }).then((result) => {
    if (result.isConfirmed) {
          openLetterDetailsSwal(result.value);
    }
  });
};



const openLetterDetailsSwal = (type) => {
  const userId = state.EmployeeProfile.EmployeeProfileList.user_id.id;
  const employeeDateOfJoining =
    state.EmployeeProfile.EmployeeProfileList?.esi_form?.date_of_joining;

  let title = "";
  let html = "";
  let getPayload = null;

  switch (type) {
  case "relinquishment":
  title = "Relinquishment From Services";
  html = `
    <div style="width:100%; text-align:left;">
      <label style="display:block; font-size:18px; margin-bottom:12px;">
        Absent Since Date
      </label>
      <input
        type="date"
        id="absentDate"
        class="swal2-input"
        min="${employeeDateOfJoining}"
        style="margin:0; width:100%; box-sizing:border-box;"
      />
    </div>
  `;
  getPayload = () => ({
    type,
    user_id: userId,
    absent_since_date: document.getElementById("absentDate").value,
  });
  break;


  case "designation_change":
  title = "Designation Change";
  html = `
    <div style="width:100%; text-align:left;">
      <label style="display:block; font-size:18px; margin-bottom:12px;">
        New Designation Start Date
      </label>
      <input
        type="date"
        id="designationDate"
        class="swal2-input"
        min="${employeeDateOfJoining}"
        style="margin:0; width:100%; box-sizing:border-box;"
      />
    </div>
  `;
  getPayload = () => ({
    type,
    user_id: userId,
    new_designation_start_date:
      document.getElementById("designationDate").value,
  });
  break;

case "role_change":
  title = "Role Change";
  html = `
    <div style="width:100%; text-align:left;">
      <label style="display:block; font-size:18px; margin-bottom:12px;">
        New Role Start Date
      </label>
      <input
        type="date"
        id="roleDate"
        class="swal2-input"
        min="${employeeDateOfJoining}"
        style="margin:0; width:100%; box-sizing:border-box;"
      />
    </div>
  `;
  getPayload = () => ({
    type,
    user_id: userId,
    new_designation_start_date:
      document.getElementById("roleDate").value,
  });
  break;

case "transfer":
  title = "Transfer Letter";
  html = `
    <div style="width:100%; text-align:left;">
      <label style="display:block; font-size:18px; margin-bottom:12px;">
        Transfer Start Date
      </label>
      <input
        type="date"
        id="transferDate"
        class="swal2-input"
        min="${employeeDateOfJoining}"
        style="margin:0; width:100%; box-sizing:border-box;"
      />
    </div>
  `;
  getPayload = () => ({
    type,
    user_id: userId,
    transfer_start_date:
      document.getElementById("transferDate").value,
  });
  break;

case "relieving":
case "experience":
  title =
    type === "relieving"
      ? "Relieving Letter"
      : "Experience Letter";

  html = `
    <div style="width:100%; text-align:left;">
      
      <div style="margin-bottom:14px;">
        <label style="display:block; font-size:18px; margin-bottom:12px;">
          From Date
        </label>
        <input
          type="date"
          id="fromDate"
          class="swal2-input"
          min="${employeeDateOfJoining}"
          style="
            margin:0;
            width:100%;
            box-sizing:border-box;
          "
        />
      </div>

      <div>
        <label style="display:block; font-size:18px; margin-bottom:12px;">
          To Date
        </label>
        <input
          type="date"
          id="toDate"
          class="swal2-input"
          min="${employeeDateOfJoining}"
          style="
            margin:0;
            width:100%;
            box-sizing:border-box;
          "
        />
      </div>

    </div>
  `;


      getPayload = () => ({
        type,
        user_id: userId,
        first_date: document.getElementById("fromDate").value,
        last_date: document.getElementById("toDate").value,
      });
      break;

    default:
      return;
  }

  Swal.fire({
    title,
    html,
    showCancelButton: true,
    confirmButtonText: "Generate",
    confirmButtonColor: "#f26639",
    cancelButtonColor: "#F69338",
    // preConfirm: () => {
    //   const payload = getPayload();
    //   const hasEmpty = Object.values(payload).some(
    //     (v) => !v && v !== type
    //   );

    //   if (hasEmpty) {
    //     Swal.showValidationMessage("Please fill all required fields");
    //     return false;
    //   }
    //   return payload;
    // },
    preConfirm: () => {
  const payload = getPayload();

  // Common empty check
  const hasEmpty = Object.entries(payload).some(
    ([key, value]) =>
      key !== "type" && key !== "user_id" && !value
  );

  if (hasEmpty) {
    Swal.showValidationMessage("Please fill all required fields");
    return false;
  }

  // Relieving / Experience specific validation
  if (type === "relieving" || type === "experience") {
    const fromDate = payload.first_date;
    const toDate = payload.last_date;

    if (new Date(toDate) < new Date(fromDate)) {
      Swal.showValidationMessage(
        "To Date must be greater than or equal to From Date"
      );
      return false;
    }
  }

  return payload;
}

  }).then((res) => {
    if (res.isConfirmed) {    
      dispatch(setGenerated_letterAction(res.value));
    }
  });
};

  return (
    <div style={{marginLeft:"42px", display:"flex",gap:"12px"}}>
<button
  className="btn"
  style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
    outline: "none", boxShadow: "none", border:"none" }}
  // onClick={() => handleSalaryRevision_new("mw_revision")}
  
    onClick={() => handleSalaryRevision_new("salary_revision")}

>
  Salary Revision
</button>

<button
  className="btn"
  style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
    outline: "none", boxShadow: "none", border:"none" }}
  onClick={() => handleSalaryRevision_new("contract")}
>
  Contract Renewal Letter
</button>

{/* <button
  className="btn"
  style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
    outline: "none", boxShadow: "none", border:"none" }}
  onClick={() => handleSalaryRevision_new("letter_changes")}
>
  Salary Revision Letter – Change Salary Structure
</button> */}


      {/* <button
        className="btn"
        style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
                outline: "none",
                boxShadow: "none",
                border:"none"
        }}
        onClick={handleSalaryRevision}
      >
        Salary Revision
      </button> */}

      <button
        className="btn "
        style={{  backgroundColor: "#ffdfd5", color: "#000",
                  outline: "none",
                  boxShadow: "none",
                  border:"none"
        }}
        onClick={handleAppointmentLetter}
      >
        Appointment Letter
      </button>

      
      <button
        className="btn"
        style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
                outline: "none",
                boxShadow: "none",
                border:"none"
        }}
        onClick={handlethe_warining}
      >
        Warning 
      </button>
      
      <button
        className="btn"
        style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
                outline: "none",
                boxShadow: "none",
                border:"none"
        }}
        onClick={handleshowcause}
      >
        Show Cause
      </button>

      <button className="btn"
              style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
                outline: "none",
                boxShadow: "none",
                border:"none"
        }}
        onClick={() => handleGenerateLetter("letters")}

      >
  Generate Letters
</button>

<button
  className="btn"
          style={{ marginRight: "10px", backgroundColor: "#ffdfd5", color: "#000",
                outline: "none",
                boxShadow: "none",
                border:"none"
        }}
  onClick={() => handleGenerateLetter("others")}
>
  Generate HR Actions
</button>


    </div>
  );
};

export default Lettersexports;
